import { rei } from "@/services/api"

class DocumentosService {
  static storeDocumentosByPessoa (pessoa_id, params) {
    return rei.post(`pessoa-documento`, { pessoa_id,  ...params }).then(res => res.data)
  }

  static deleteDocumento (pessoa_documento_id) {
    return rei.delete(`pessoa-documento/${pessoa_documento_id}`).then(res => res.data)
  }

  static getDocumento (documentoId, origem, query) {
    const config = {
      responseType: 'arraybuffer',
      params: {
        origem
      }
    }

    return rei.get(`documentos/${documentoId}/visualizar/${origem}?query=${query}`, config)
      .then(res => res.data)
  }

  static getLivroDeRegistro (registroId) {
    return rei.get('documento-livro-de-registro', { params: { registroId } }).then(res => res.data)
  }
}

export default DocumentosService
